import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import userStore from "../../zustand/user.store";
import { deleteAuthAndUserFromIndexDB } from "../../helpers/indexDb.helpers";
import MobileHeader from "../components/MobileHeader";
import styles from "./MobileProfile.module.scss";

const MobileProfile = () => {
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate();
  const { user, flushUserData } = userStore((state) => ({
    user: state.user,
    flushUserData: state.flushUserData,
  }));

  const handleLogout = () => {
    localStorage.clear();
    flushUserData();
    deleteAuthAndUserFromIndexDB();
  };

  const displayName = user?.firstname
    ? `${user.firstname} ${user.lastname || ""}`.trim()
    : user?.username;

  return (
    <div className={styles.page}>
      <MobileHeader title="Profile" />

      <div className={styles.playerBadge}>
        <span className={styles.playerLabel}>4Play Player</span>
        <span className={styles.playerName}>{user?.business_name || user?.name || displayName}</span>
      </div>

      <div className={styles.card}>
        <div className={styles.avatar}>
          {(user?.firstname?.[0] || user?.username?.[0] || "U").toUpperCase()}
        </div>
        <p className={styles.name}>{displayName}</p>
        {user?.email && <p className={styles.email}>{user.email}</p>}
      </div>

      <div className={styles.fields}>
        <div className={styles.field}>
          <span className={styles.fieldLabel}>Username</span>
          <span className={styles.fieldValue}>{user?.username || "-"}</span>
        </div>
        <div className={styles.field}>
          <span className={styles.fieldLabel}>Full Name</span>
          <span className={styles.fieldValue}>
            {user?.firstname ? `${user.firstname} ${user.lastname || ""}` : "-"}
          </span>
        </div>
        <div className={styles.field}>
          <span className={styles.fieldLabel}>Email</span>
          <span className={styles.fieldValue}>{user?.email || "-"}</span>
        </div>
      </div>

      <button className={styles.contactBtn} onClick={() => navigate("/mobile/contact")}>
        Contact Us
      </button>

      <button className={styles.logoutBtn} onClick={() => setShowLogout(true)}>Logout</button>

      {showLogout && (
        <div className={styles.overlay} onClick={() => setShowLogout(false)}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <p className={styles.modalTitle}>Are you sure you want to logout?</p>
            <div className={styles.modalActions}>
              <button className={styles.modalCancel} onClick={() => setShowLogout(false)}>Cancel</button>
              <button className={styles.modalConfirm} onClick={handleLogout}>Logout</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileProfile;
